export const ALERT_ROLES = [
  { value: "customer_service", label: "Customer service" },
  { value: "management", label: "Management" },
  { value: "logistics", label: "Logistics" },
];

export const COMMENT_TYPE_GROUPS = [
  { type: "comment_ka", label: "Customer service" },
  { type: "comment_management", label: "Management" },
  { type: "comment_logistic", label: "Logistics" },
];

export const NO_TEMPLATE = "no_template";

export const ruleLabel = (rule, rules = []) => {
  if (!rule) return "No template";
  return rules.find((item) => item.value === rule)?.label || rule;
};

export const commentStatesLabel = (alert, rules = [], commentStates = []) => {
  if (alert.rule) {
    return rules.find((item) => item.value === alert.rule)?.comment || "-";
  }

  const names = (alert.comment_state_ids || [])
    .map((id) => commentStates.find((state) => state.id === id)?.name)
    .filter(Boolean);

  return names.length > 0 ? names.join(", ") : "-";
};

export const roleLabel = (role) =>
  ALERT_ROLES.find((item) => item.value === role)?.label || role || "-";

export const dayOptions = Array.from({ length: 31 }, (_, i) => ({
  value: i,
  label: `${i} day${i === 1 ? "" : "s"}`,
}));

export const hourOptions = Array.from({ length: 24 }, (_, i) => ({
  value: i,
  label: `${i} hour${i === 1 ? "" : "s"}`,
}));

export const timeOptions = (() => {
  const options = [];
  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += 15) {
      const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
      options.push({ value, label: value });
    }
  }
  return options;
})();

export const triggerLabel = (alert) => {
  if (alert.trigger_mode === "exact") {
    const times = alert.exact_times || [];
    if (times.length === 0) return "No time set";
    if (times.length > 2) {
      return `At ${times.slice(0, 2).join(", ")} +${times.length - 2}`;
    }
    return `At ${times.join(", ")}`;
  }

  const days = Number(alert.days) || 0;
  const hours = Number(alert.hours) || 0;
  const parts = [];
  if (days > 0) parts.push(`${days} day${days === 1 ? "" : "s"}`);
  parts.push(`${hours} hour${hours === 1 ? "" : "s"}`);
  return parts.join(", ");
};
